module.exports = __webpack_public_path__ + "static/img/3394_phase_function_Paper_PointsHejduk_Prediction.5fc5702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3394_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 8kZj
// module chunks = 0